import React, { Suspense } from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { ImageStats, ImageUploadDataGrid } from "../components/image";
import DataGridTitle from "../components/common/DataGridTitle";
import StatSkeleton from "../components/common/StatSkeleton";
import ImageUploadTile from "../components/image/ImageUploadTile";

const ImageRepofragment = () => {
  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Suspense fallback={<StatSkeleton tiles={2} />}>
          <ImageStats />
        </Suspense>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <ImageUploadTile />
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined">
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <ImageUploadDataGrid tableTitle="Available Images" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default ImageRepofragment;
